import { render, staticRenderFns } from "./Density.vue?vue&type=template&id=4cb60450&scoped=true&"
import script from "./Density.vue?vue&type=script&lang=js&"
export * from "./Density.vue?vue&type=script&lang=js&"
import style0 from "./Density.vue?vue&type=style&index=0&id=4cb60450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb60450",
  null
  
)

export default component.exports